import { Routes } from '@angular/router'

import { environment } from '@demo/env/environment'

import { authGuard } from './core/auth/auth.guard'
import { redirectIfAuthGuard } from './core/auth/redirect-if-auth.guard'
import { interactionRoutes } from './pages/interactions/interactions.routes'

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/main/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      ...(environment.features['module.freeMode']
        ? ([
            {
              path: '',
              loadComponent: () =>
                import(
                  '@yoshu-lib/features/interaction-modes/free-mode/start-free-mode/start-free-mode.component'
                ).then((m) => m.StartFreeModeComponent)
            }
          ] as Routes)
        : []),

      {
        path: 'interactions',
        canActivate: [authGuard],
        children: interactionRoutes
      },

      {
        path: 'conversations',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/interactions-list/interactions-list.component').then(
            (m) => m.InteractionsListComponent
          )
      }
    ]
  },
  {
    path: 'login',
    canActivate: [redirectIfAuthGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent)
  },

  {
    path: '**',
    redirectTo: ''
  }
]
